<template>
  <div class="pa-6 rounded-xl shadow-lg form-container">
    <div class="reg-title text-center mb-3">
      <v-icon class="mr-2" color="secondary">mdi-school</v-icon> 
      School Registration
    </div>
    
    <div class="info-container">
      <div class="info-item" >
        <v-icon class="info-icon" color="secondary">mdi-domain</v-icon>
        <span><strong>School:</strong> {{ form.schoolName }}</span>
      </div>

      <div class="info-item">
        <v-icon class="info-icon" color="secondary">mdi-phone</v-icon>
        <span><strong>Contact:</strong> {{ form.schoolContact }}</span>
      </div>

      <div class="info-item">
        <v-icon class="info-icon" color="secondary">mdi-map-marker</v-icon>
        <span><strong>Address:</strong> {{ form.schoolAddress }}</span>
      </div>

      <div class="info-item">
        <v-icon class="info-icon" color="secondary">mdi-account-tie</v-icon>
        <span><strong>Principal:</strong> {{ form.principalName }}</span>
      </div>

      <v-divider class="my-3"></v-divider>

      <div class="info-item">
        <v-icon class="info-icon" color="secondary">mdi-account</v-icon>
        <span><strong>User:</strong> {{ form.first_name }} {{ form.last_name }}</span>
      </div>

      <div class="info-item " >
        <v-icon class="info-icon" color="secondary">mdi-phone</v-icon>
        <span><strong>Contact:</strong> {{ form.contact }}</span>
      </div>

      <!-- <div class="info-item">
        <v-icon class="info-icon" color="secondary">mdi-email</v-icon>
        <span><strong>Email:</strong> {{ form.email }}</span>
      </div> -->
    </div>

    <v-btn 
      class="mt-4 register-btn"
      block
      color="primary"
      @click="handleClick"
      elevation="3"
      :disabled="disabled"
      :loading="loading"
    >
      <v-icon left>mdi-check-circle</v-icon>
      Register School
    </v-btn>

    <!-- Error message display -->
    <v-alert
      v-if="errorMessage"
      type="error"
      class="mt-3"
    >
      {{ errorMessage }}
    </v-alert>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  form: {
    type: Object,
    required: true,
  },
  handleSignUp: {
    type: Function,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const loading = ref(false);
const errorMessage = ref('');

const handleClick = async () => {
  if (props.disabled) return;
  
  loading.value = true;
  errorMessage.value = '';
  
  try {
    await props.handleSignUp();
  } catch (error) {
    errorMessage.value = error.message || 'Registration failed. Please try again.';
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
/* Your existing styles can remain the same */
.form-container {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
}

.reg-title {
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1.4rem;
}

.info-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
}

.info-icon {
  margin-right: 10px;
}

.register-btn {
  font-weight: bold;
  text-transform: uppercase;
  transition: transform 0.2s ease;
}

.register-btn:hover {
  transform: scale(1.05);
}
</style>